export const getBreadcrumbItems = (pathname, product) => {
  const items = [];

  if (pathname.includes('/settings')) {
    items.push({
      id: 'settings',
      to: `/settings/${product}`,
      label: 'Settings',
    });

    if (pathname.includes('/settings')) {
      if (pathname.includes('/workflow')) {
        items.push({
          id: 'workflow',
          to: '/settings/docchat/workflow',
          label: 'Workflow',
        });

        if (pathname.includes('/create')) {
          items.push({
            id: 'create-workflow',
            label: 'Create New Workflow',
          });
        } else if (pathname.includes('/edit/')) {
          items.push({
            id: 'edit-workflow',
            label: 'Edit Workflow',
          });
        }
      } else {
        items.push({
          id: 'profile',
          label: 'Profile',
        });
      }
    }
  }

  return items;
};
